import { jsx as r } from "react/jsx-runtime";
import { useState as p } from "react";
import { useMultiStyleConfig as f, Box as t } from "@chakra-ui/react";
import { PersonsIcon as i } from "../../icons/index.es.js";
const u = ({ src: o, alt: n, styles: c }) => {
  const [s, e] = p(!1);
  return o && !s ? /* @__PURE__ */ r("img", { src: o, alt: n, onError: () => e(!0) }) : /* @__PURE__ */ r(t, { __css: c.error, children: /* @__PURE__ */ r(i, { ...c.errorIcon }) });
}, x = ({ __css: o, avatars: n, size: c }) => {
  const s = f("AvatarList", { size: c });
  return n.length ? /* @__PURE__ */ r(t, { __css: { ...s.base, ...o }, children: /* @__PURE__ */ r(t, { __css: s.inner, children: n.slice(0, 4).map((e, _) => {
    const l = typeof e == "string" ? e : e.src, m = typeof e == "string" ? "" : e.alt;
    return /* @__PURE__ */ r(t, { __css: s.item, children: /* @__PURE__ */ r(u, { src: l, alt: m, styles: s }) }, _);
  }) }) }) : /* @__PURE__ */ r(t, { __css: s.base, children: /* @__PURE__ */ r(t, { __css: s.empty, children: /* @__PURE__ */ r(i, { ...s.emptyIcon }) }) });
};
export {
  x as AvatarList
};
//# sourceMappingURL=AvatarList.es.js.map
